(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name     : 'FranchiseCreditCardManage',
		submitted: false,
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.confirmation = function confirmation(response)
	{
		Adzuki.CustomConfirm({
			body   : response.data.message,
			confirm: function onConfirm() {
				$('#franchisecreditcardmanage-bypass_confirmation').val('1');

				$(form.element).submit();
			},
			cancel: function onCancel() {
				// do nothing
			}
		});
	};
}(jQuery, window.Adzuki || {}));
